module.exports = __webpack_public_path__ + "img/horizontal_4_6_pp13_3009.b947a720.png";